import React, { useEffect, useRef, useState } from "react";
import backCpayIcon from "../img/cpay-svg/arrow-back.svg";
import backNFGIcon from "../img/nfgpay-svg/arrow-back-nfg.svg";
import backFinvaroIcon from "../img/finvaro/arrow-back-finvaro.svg";
import backClarniumIcon from "../img/clarnium/arrow-back-clarnium.svg";
import backInexIcon from '../img/inex/arrow-back-inex.svg';
import backInstaIcon from '../img/instaXchange/arrow-back-insta.svg';
import backCoineraIcon from '../img/coinera/arrow-back-coinera.svg';
import { Link, useParams } from "react-router-dom";
import { identity } from "../utils/getIdentity";
import { Card } from "antd";
import { scrollContainerIntoView } from "../adminPanel/helpers/scrollIntoView";
import TEXT from "../adminPanel/components/Text";
import { getUserLoginHistory } from "../redux/actions/adminPanel/adminSettings";
import { connect } from "react-redux";
import LoginHistoryList from "../components/LoginHistoryList/LoginHistoryList";
import { useTranslation } from "react-i18next";

const backIcon = {
  cpay: backCpayIcon,
  nfg: backNFGIcon,
  finvaro: backFinvaroIcon,
  clarnium: backClarniumIcon,
  inex: backInexIcon,
  insta: backInstaIcon,
  coinera: backCoineraIcon
};
const LoginHistoryPage = ({ getUserLoginHistory, loginHistory }) => {
  const { userId } = useParams();
  const adminUserLoginHistoryRef = useRef();
  const { t } = useTranslation()

  useEffect(() => {
    if (userId) {
      getUserLoginHistory(userId, { page: 1 });
    }
  }, [userId]);

  useEffect(() => {
    scrollContainerIntoView(adminUserLoginHistoryRef);
  }, []);

  return (
    <div className="admin-user-transactions" ref={adminUserLoginHistoryRef}>
      <Card>
        <Link
          className={`admin-user-transactions__arrow-back admin-user-transactions__arrow-back-${identity}`}
          to="/admin/users"
        >
          <img src={backIcon[identity]} alt="arrow back" /> <span>{t('admin.go_back')}</span>
        </Link>
        <TEXT.pageTitle>{t('admin.login_history')}</TEXT.pageTitle>
        {loginHistory?.data?.length > 0 ? (
          <LoginHistoryList loginHistory={loginHistory} limit={5} getUserLoginHistory={getUserLoginHistory} userId={userId}/>
        ) : (
          <div className={`admin-user-transactions-empty admin-user-transactions-empty-${identity}`}>{t('admin.not_history')}</div>
        )}
      </Card>
    </div>
  )
};

const mapStateToProps = state => ({
  loginHistory: state.adminSettings.loginHistory
});

const mapDispatchToProps = {
  getUserLoginHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginHistoryPage);